import { EventEmitter, Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Media } from './template-constants';
import { StorageKeys } from '../shared-module-files/simpo.constant';
import { Observable } from 'rxjs';

// import { Media } from 'aws-sdk/clients/transcribeservice';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {
  updateElements = new EventEmitter<any>();
  scrollToComponent = new EventEmitter<any>();
  secondaryEditor = new EventEmitter<any>();
  goBack = new EventEmitter<any>();
  focusContentBlock = new EventEmitter<{ blockType: string; data?: any }>();
  private apiUrl = 'https://api.unsplash.com';

  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    private snackbar: MatSnackBar,
    private _bottomSheet: MatBottomSheet
  ) {
  }

  // Unsplash
  searchPhotosInUnsplash(
    searchedText: string,
    page: number = 1,
    size: number = 10
  ) {
    const header = new HttpHeaders({
      Authorization: `Client-ID ${environment.unsplash.UNSPLASH_API_TOKEN}`,
    });

    return this.http.get(
      `https://api.unsplash.com/search/photos?page=${page}&per_page=${size}&query=${searchedText}`,
      {
        headers: header,
      }
    );
  }

  // Shutterstock
  searchPhotosInShutterstock(
    searchedText: string,
    page: number = 1,
    size: number = 10
  ) {
    const header = new HttpHeaders({
      Authorization: `Bearer ${environment.shutterstock.SHUTTERSTOCK_API_TOKEN}`,
    });

    return this.http.get(
      `https://api.shutterstock.com/v2/images/search?page=${page}&per_page=${size}&query=${searchedText}`,
      {
        headers: header,
      }
    );
  }

  // Media library
  saveImagesToBusinessLibrary(mediaRequest: { data: Media[] }) {
    return this.http.post(
      environment.serverIp + `library/image/library/save`,
      mediaRequest
    );
  }

  getSavedImagesInLibrary(
    businessId: string,
    platform: MediaSource | string,
    pageNo: number,
    size: number
  ) {
    return this.http.get(
      environment.serverIp +
      `library/image/library/list/paged?pageNo=${pageNo}&size=${size}&businessId=${businessId}&platform=${platform}`
    );
  }

  debounce(fn, duration: number = 500) {
    let timeout: ReturnType<typeof setTimeout> | null = null;

    return function () {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => fn(), duration);
    };
  }

  getAllBusinessName(subCategoryId: any) {
    return this.http.get(
      environment.serverIp + `master/business/name/${subCategoryId}?size=100&page=0`
    )
  }

  intiateTemplateData(data: any) {
    return this.http.post(
      environment.baseUrl + `business/website/create`, data
    )
  }

  getTemplateDataByTemplateId(tempId: any) {
    return this.http.get(
      environment.baseUrl + `business/website/?websiteId=${tempId}`
    )
  }

  updateTemplateData(data: any) {
    return this.http.post(
      environment.baseUrl + `business/website/create`, data
    )
  }

  getBusinessCategoryImages(subIndustryId: any) {
    return this.http.get(
      environment.serverIp + `master/business/images?subIndustryId=` + subIndustryId
    )
  }

  openDialogWithData(componentName: any, height: any, width: any, dataModel: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
      maxWidth: '100vw'
    });
  }

  openDialog(componentName: any, height: any, width: any, dataModel: any, panelClass?: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
      maxWidth: '100vw',
      panelClass: panelClass
    });
  }

  openSnackbar(message: string) {
    this.snackbar.open(message, 'Ok', {
      duration: 1500,
    });
  }

  openSnack(message: any, action: any) {
    this.snackbar.open(message, action, { duration: 5000 });
  }

  openBottomSheet(componentName: any, dataModel: any, panelClass: string) {
    return this._bottomSheet.open(componentName, {
      data: dataModel,
      panelClass: panelClass
    });
  }

  //new Apis
  // regenerateComponentCategory(componentCategoryId:any,subBusinessCategoryId:any){
  //   return this.http.get(
  //     environment.baseUrl+`adminmaster/template/builder/component?categoryId=${componentCategoryId}&subIndustryId=${subBusinessCategoryId}`
  //   )
  // }

  getBusinessDetailsById(id: any) {
    return this.http.get(
      environment.baseBusinessUrl + `business/${id}`
    )
  }

  getTemplateStructure(subCategoryId: any) {
    return this.http.get(
      environment.serverIp + `master/template?subIndustryId=${subCategoryId}`
    )
  }

  getComponentsData(componentId: any, componentCategoryId: any, subBusinessCategoryId: any) {
    if (componentId === null) {
      return this.http.get(
        environment.serverIp + `master/template/builder/component?categoryId=${componentCategoryId}&subIndustryId=${subBusinessCategoryId}`
      )
    } else {
      return this.http.get(
        environment.serverIp + `master/template/builder/component?componentId=${componentId}&categoryId=${componentCategoryId}&subIndustryId=${subBusinessCategoryId}`
      )
    }
  }

  regenerateComponents(componentCategoryId: any, subIndustryId: any, componentId: any, contentId: any) {
    if (contentId != null) {
      return this.http.get(
        environment.serverIp + `master/template/builder/component/regenerate?categoryId=${componentCategoryId}&subIndustryId=${subIndustryId}&componentId=${componentId}&contentId=${contentId}`
      )
    } else {
      return this.http.get(
        environment.serverIp + `master/template/builder/component/regenerate?categoryId=${componentCategoryId}&subIndustryId=${subIndustryId}&componentId=${componentId}`
      )
    }
  }

  changeContent(categoryId: any, subIndustryId: any, contentId: any) {
    return this.http.get(
      environment.serverIp + `master/template/builder/component/content?categoryId=${categoryId}&subIndustryId=${subIndustryId}&contentId=${contentId}`
    )
  }

  mergedIndustrySubIndustry() {
    return this.http.get(
      environment.serverIp + `master/business/industry/sub?size=1000&page=0`
    )
  }

  getSubIndustry(pageNo: number, size: number) {
    return this.http.get(environment.serverIp + `master/business/industry/sub/v2?size=${size}&page=${pageNo}`)
  }

  getAllSubIndustriesV2() {
    return this.http.get(environment.baseUrl + `admin/master/business/industry/sub/all`)
  }

  getBlogsByBuisnessId(businessId: any, blogStauts: any) {
    return this.http.get(
      environment.baseUrl + `business/blog/businessId/${businessId}?blogStatus=${blogStauts}`
    )
  }

  getBlogsBySubInstryId(subIndustryId: any) {
    return this.http.get(
      environment.serverIp + `blog/getBlog/${subIndustryId}`
    )
  }

  //v2 integrations

  getWebsiteWithAllPages(id: any) {
    return this.http.get(
      environment.baseUrl + `business/website/v2/all?websiteId=${id}`
    )
  }

  getWebsiteWithWebCode(webCode: any) {
    return this.http.get(
      environment.baseUrl + `business/website/v2/getBy/websiteCode?websiteCode=${webCode}`
    )
  }

  updateWebsiteData(data: any) {
    return this.http.put(
      environment.baseUrl + `business/website/v2/`, data
    )
  }

  regenerateComponent(data) {
    return this.http.get(
      environment.serverIp + `master/template/v2/component/regenerate?websiteId=${data.templateId}&index=${data.index}&subIndustryId=${data.subIndustryId}`
    )
  }

  changeComponentContent(data) {
    return this.http.get(
      environment.serverIp + `master/template/v2/component/content?websiteId=${data.templateId}&index=${data.index}&subIndustryId=${data.subIndustryId}`
    )
  }

  getLocalComponentWithData(index: any, homePageId: any, componentId: any, subIndustryId: any, pageId: string) {
    if (pageId) {
      return this.http.get(
        environment.serverIp + `master/template/v2/component/data?index=${index}&homePageId=${homePageId}&componentId=${componentId}&subIndustryId=${subIndustryId}&pageId=${pageId}`
      )
    } else {
      return this.http.get(
        environment.serverIp + `master/template/v2/component/data?index=${index}&homePageId=${homePageId}&componentId=${componentId}&subIndustryId=${subIndustryId}`
      )
    }
  }

  updateNewSection(index: number, pageId: String, data: any) {
    return this.http.put(
      environment.serverIp + `master/template/v2/custom-component/data?index=${index}&pageId=${pageId}`, data
    )
  }

  deleteComponent(index: number, pageId: string) {
    return this.http.delete(
      environment.serverIp + `master/template/v2/component/delete?index=${index}&pageId=${pageId}`
    )
  }

  updateData(data) {
    return this.http.post(
      environment.baseUrl + `business/website/v2/create`, data
    )
  }

  reStylePages(data) {
    return this.http.put(
      environment.serverIp + `master/website/style`, data
    )
  }

  getWebsiteData(url: string) {
    return this.http.get(
      url, { responseType: 'text' }
    )
  }

  getAddress(lat, lng) {
    return this.http.get(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyDjOcdDo78v7TuPUrmdX-UxAUjOx5J7KQU`
    )
  }

  deletePage(pageId) {
    return this.http.delete(
      environment.baseUrl + `business/website/v2?pageId=${pageId}&deleteAll=false`
    )
  }

  getMasterDepartment(pageNo: number, size: number) {
    return this.http.get(
      environment.serverIp + `master/hrms/department?pageNo=${pageNo}&size=${size}`
    )
  }

  getMasterDesignation(request: any) {
    return this.http.put(
      environment.serverIp + `master/hrms/designation/filter`, request
    )
  }

  generateLead(data: any) {
    return this.http.post(
      environment.businessWithOutGateway + `business/website/leads`, data
    )
  }

  updateLead(subId: any, subName: any, leadId: any) {
    return this.http.put(
      environment.businessWithOutGateway + `business/lead/message?leadId=${leadId}&subId=${subId}&subName=${subName}`, ''
    )
  }

  //v3 api's for website generation
  generateV3Website(data: any) {
    return this.http.put(
      environment.regenerateUrl + `v3/website`, data
    )
  }

  generateWebsiteThroughAI(data: any) {
    return this.http.post(
      environment.aiGeneratingBaseUrl + `api/generate-content`, data
    )
  }

  getWebsiteTemplateById(templateId: any) {
    return this.http.get(
      environment.baseUrl + `business/v3/website/${templateId}/pages/list`
    )
  }

  updatePageSeo(payload) {
    return this.http.put(
      environment.baseBusinessUrl + `v3/business/update/page/seo`, payload
    )
  }

  getWebsiteTemplate(templateId: string, defaultTemplate: boolean = true) {
    if (defaultTemplate)
      return this.http.get(environment.baseUrl + `business/v3/website/${templateId}/pages/list`);
    else
      return this.http.get(environment.baseBusinessUrl + `template-library/${templateId}/website-content/details`)
  }

  getSectionForIndustry(sectionId: any, subIndustryId: any, businessName: string, businessId: any) {
    return this.http.get(
      environment.serverIp + `v3/add/section?subIndustryId=${subIndustryId}&componentId=${sectionId}&name=${businessName}&businessId=${businessId}`
    )
  }

  getSectionContent(sectionId: any, subIndustryId: any, businessName: string) {
    return this.http.get(
      environment.serverIp + `v3/content/?subId=${subIndustryId}&componentId=${sectionId}&name=${businessName}`
    )
  }

  saveTemplatePage(data: any, isDefaultTemplate: boolean = true, templateId?: any) {
    if (isDefaultTemplate) {
      return this.http.post(
        environment.baseUrl + `business/v3/create/website`, data
      )
    } else {
      let payload = { websiteContentV3List: data }
      return this.http.put(
        environment.baseBusinessUrl + `template-library/${templateId}/save`, payload
      )
    }

  }

  getAllThemePallet() {
    return this.http.get(
      environment.serverIp + `master/template/v2/all-themes`
    )
  }

  deleteWebsitePage(pageId: string) {
    return this.http.delete(
      environment.baseUrl + `business/v3/delete/page?pageId=${pageId}`
    )
  }

  v3getWebsiteWithWebCode(websiteCode: any) {
    return this.http.get(
      environment.baseUrl + `business/v3/websiteCode?websiteCode=${websiteCode}`
    )
  }

  getPageBySubIndustryId(subIndustryId: any, pageId: any) {
    return this.http.get(
      environment.serverIp +
      `v3/random/page?subId=${subIndustryId}&categoryId=${pageId}`
    );
  }

  pageNameCategories(subId: any) {
    return this.http.get(
      environment.baseUrl + `admin/master/template/v2/page/category?subId=${subId}`
    );
  }

  getImageData(data: any) {
    return this.http.put(
      environment.baseUrl + `admin/v3/image`, data
    );
  }

  createFolder(data: any) {
    return this.http.post(
      environment.baseUrl + `business/folder`, data
    )
  }

  deleteFolder(folderId: any) {
    return this.http.delete(
      environment.baseUrl + `business/folder?folderId=${folderId}`
    )
  }

  getAllFolder(data: any) {
    return this.http.put(
      environment.baseUrl + `business/folder`, data
    )
  }

  getNotificationsData(businessId: any, staffId: any) {
    return this.http.get(
      environment.baseBusinessUrl + `notifications/businessId?businessId=${businessId}&staffId=${staffId}`
    );
  }

  notificationSeenStatus(notificationId: any) {
    return this.http.put(
      environment.baseBusinessUrl + `notifications/update/seenStatus?notificationId=${notificationId}`, notificationId
    )
  }

  notificationBulkSeenStatus(businessId: any, staffId: any) {
    return this.http.patch(
      environment.baseUrl + `business/notifications/update/seenStatus/bulk?businessId=${businessId}&staffId=${staffId}`, businessId
    )
  }

  getUnseenDataCount(businessId: any, staffId: any) {
    return this.http.get(
      environment.baseBusinessUrl + `notifications/unseen/get?businessId=${businessId}&staffId=${staffId}`
    );
  }

  getFavIcon(businessId: any) {
    return this.http.get(
      environment.baseUrl + `business/v3/get/favicon?businessId=${businessId}`
    )
  }

  updateFavicon(businessId: any, favIcon: any) {
    return this.http.put(
      environment.baseUrl + `business/v3/update/favicon?businessId=${businessId}&favIcon=${favIcon}`, ''
    )
  }

  getTemplateLibrary() {
    const subId = localStorage.getItem(StorageKeys.SUBINDUSTRYID);
    return this.http.get(
      environment.baseUrl + `admin/v3/template/admin/list?subIndustryId=${subId}`
    )
  }

  getBusinessThemes() {
    let businessId = localStorage.getItem('businessId');
    return this.http.get(
      environment.baseBusinessUrl + `template-library/${businessId}`
    )
  }

  addToBusinessLibrary(data) {
    return this.http.put(
      environment.baseUrl + `admin/v3/business-template/library/add`, data
    )
  }

  publishTemplate(templateId: string) {
    return this.http.put(
      environment.baseBusinessUrl + `template-library/${templateId}/publish`, ''
    )
  }

  deleteTheme(templateId: string) {
    return this.http.delete(
      environment.baseBusinessUrl + `template-library/${templateId}`
    )
  }

  addNewPage(websiteCode: string, payload) {
    return this.http.post(
      environment.baseUrl + `business/v3/add-page?websiteCode=${websiteCode}`, payload
    )
  }
  getCategoryList(data) {
    return this.http.put(
      environment.baseUrl + `admin/social-template/category/filter`, data
    )
  }

  getTemplatesByBusiness(bId: any, payload: any) {
    return this.http.put(
      environment.newServerIp + `template/${bId}/filter`, payload
    )
  }
  getGoalsList(data) {
    return this.http.put(
      environment.baseUrl + `admin/social-template/goal/filter`, data
    )
  }

  getSubIndustryTemplates(payload: any) {
    return this.http.put(
      environment.baseUrl + `admin/social-template/template/filter`, payload
    )
  }
  getPlatformsList(): Observable<{ data: string[] }> {
    return this.http.get<{ data: string[] }>(
      `${environment.baseUrl}admin/social-template/platform`
    );
  }
  getSubIndustries(page: number, size: number) {
    return this.http.get(
      environment.baseUrl +
      `admin/master/business/industry/sub/count?pageNo=${page}&size=${size}`
    );
  }
}
